// next-intl's strict key type forces awkward generic gymnastics for a
// helper this small. We accept any translator-shaped function and rely on
// the caller's namespace to expose `waitTime.seconds` / `waitTime.minutes`.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type LooseTranslator = (...args: any[]) => string

export function formatWaitTime(seconds: number, t: LooseTranslator): string {
  const total = Math.max(0, Math.ceil(seconds))
  if (total < 60) return t('waitTime.seconds', { count: total })
  const minutes = Math.ceil(total / 60)
  return t('waitTime.minutes', { count: minutes })
}
